(ns app.front.view.inspections.ws-violations
  (:require [app.domain.inspection.model :as inspection-model]
            [app.domain.util :as du]
            [app.front.process :as process]
            [app.front.ui :as ui]
            [app.front.ui.table :as ui-table]
            [app.front.view.inspections.section :as inspections-section]
            [app.front.view.workspace.section :as ws-section]
            [app.front.view.workspace.subs :as ws-subs]
            [app.rich-text :as rich-text]
            [core.front.carbon :as cc]
            [core.front.date-util :as date-util]
            [core.front.event :refer [<sub >evt]]
            [core.front.href :as href]
            [core.user.model :as user-model]
            [re-frame.core-instrumented :as rf]))

(rf/reg-sub ::all-execution-violations
  (fn [[_ target-id]]
    (rf/subscribe [::inspections-section/inspections-raw target-id]))
  (fn [inspections _]
    (->> inspections
         (mapcat :entity/_parent)
         (filter #(and (-> % :inspection.deficiency/subtype (= :inspection.deficiency.subtype/violation))
                       (du/is-active? %)))
         (sort-by :entity/created))))

(defn show-reference-handler [violations _]
  (some :inspection.deficiency/reference violations))

(rf/reg-sub ::show-reference-for-execution-violations?
  (fn [[_ target-id]]
    (rf/subscribe [::all-execution-violations target-id]))
  show-reference-handler)

(defn- status-text [deficiency tr]
  (let [draft?   (= (-> deficiency :domain/state) :inspection.deficiency.state/draft)
        remark?  (-> deficiency :inspection.deficiency/remark?)
        cleared? (= (-> deficiency :domain/state) :inspection.deficiency.state/cleared)]
    (cond
      draft? (tr [:deficiencies/draft])
      remark? (tr [:deficiencies/remark])
      cleared? (tr [:yes])
      (not cleared?) (tr [:no]))))

(defn- status-for-table [deficiency]
  (let [remark?      (-> deficiency :inspection.deficiency/remark?)
        not-remark?  (not remark?)
        cleared?     (= (-> deficiency :domain/state) :inspection.deficiency.state/cleared)
        not-cleared? (not cleared?)]
    (cond
      (and not-remark? cleared?) :ok
      (and not-remark? not-cleared?) :critical
      :else :notification)))

(defn- render-external-id [tr execution-id backend-sys-name deficiency]
  (cond
    (-> deficiency :inspection.deficiency/integration-sync-state (= :in-progress))
    (cc/inline-loading {:description (tr [:process.signal.loading/sync-to-back-end-system]
                                         [backend-sys-name])})

    (and (-> deficiency :inspection.deficiency/integration-sync-state (= :not-synced))
         (<sub [::process/execution-signal-permitted?
                [:process.signal/resend-violation-to-integration
                 {:deficiency-id (:db/id deficiency)}]]))
    (cc/button {:kind     :tertiary
                :size     :small
                :on-click #(>evt [::process/signal
                                  execution-id
                                  [:process.signal/resend-violation-to-integration
                                   {:deficiency-id (:db/id deficiency)}]])}
               (tr [:synchronization/resend]))

    :else
    (:inspection.deficiency/external-id deficiency "")))

(defn violations-for-workspace [{:keys [tr execution] :as state}]
  (let [execution-id     (:db/id execution) ;; TODO only showing violations from execution
        violations       (<sub [::all-execution-violations execution-id])
        show-ext-id?     (some :inspection.deficiency/integration-sync-state violations)
        backend-sys-name (when show-ext-id?
                           (<sub [::ws-subs/backend-system-name]))
        lang             (<sub [:language])
        format-date      (<sub [::date-util/date-fn])]
    (when (seq violations)
      [ws-section/section
       execution-id
       :execution-violations
       state
       :violations/section-heading
       true
       [ui-table/modern-responsive-table
        {:items      violations
         :link       {:description (tr [:violations/open-inspection])
                      :make-href   (fn [violation]
                                     (let [inspection (-> violation :entity/parent)]
                                       (href/href :view/inspection-visit
                                                  {:workspace-id  (-> inspection inspection-model/workspace :workspace/id)
                                                   :inspection-id (-> inspection :db/id)})))}
         :get-status status-for-table
         :id-func    :db/id
         :cols       [[(tr [:deficiencies/compliant])
                       (fn [violation]
                         [:span.uppercase (status-text violation tr)])
                       {:max-width "90px"}]
                      [(tr [:deficiencies/description])
                       #(-> %
                            :inspection.deficiency/description
                            rich-text/join-rich-text-content
                            (ui/text-to-paragraphs "mt-1 first:mt-0 leading-snug"))
                       {:flex 2}]
                      (when (<sub [::show-reference-for-execution-violations? execution-id])
                        [(tr [:deficiencies/reference])
                         #(-> %
                              :inspection.deficiency/reference
                              rich-text/join-rich-text-content
                              (ui/text-to-paragraphs "mt-1 first:mt-0 leading-snug"))
                         {:flex 1}])
                      [(tr [:deficiencies/compliance-date])
                       #(or (some-> % :inspection.deficiency/cleared format-date) "-")
                       {:max-width "120px"}]
                      [(tr [:deficiencies/discovery-date])
                       #(some-> % :entity/created format-date)
                       {:max-width "120px"}]
                      (when show-ext-id?
                        [(str backend-sys-name " ID")
                         #(render-external-id tr execution-id backend-sys-name %)
                         {:max-width "90px"}])
                      [(tr [:inspection/inspector])
                       #(or (some-> % :inspection.deficiency/cleared-by user-model/full-name)
                            (-> % :entity/creator user-model/full-name))
                       {}]
                      [(tr [:violations/inspection-type])
                       #(-> % :entity/parent (inspection-model/inspection-name lang))
                       {}]]}]])))
